export const getTokenUnit = (chain) => {
  switch (chain) {
    case 'ethereum':
      return 'ETH';
    case 'near':
      return 'NEAR';
    case 'polygon':
      return 'MATIC';
    case 'chiliz':
      return 'CHZ';
    case 'flow':
      return 'FLOW';
    case 'ordinals':
      return 'BTC';
    case 'etherlink':
      return 'XTZ';
    case 'tezos':
      return 'XTZ';
    case 'rootstock':
      return 'BTC';
    default:
      return 'ETH';
  }
};

export const getPlatformTokenUnit = (chain) => {
  switch (chain) {
    case 'ethereum':
      return 'ETH';
    case 'near':
      return 'NEAR';
    case 'polygon':
      return 'ETH';
    case 'chiliz':
      return 'ETH';
    case 'flow':
      return 'FLOW';
    case 'ordinals':
      return 'BTC';
    case 'etherlink':
      return 'XTZ';
    case 'tezos':
      return 'XTZ';
    case 'rootstock':
      return 'BTC';
    default:
      return 'ETH';
  }
};
